const FlagNZ = props => (
	<svg height="28" viewBox="0 0 100 100" width="28" {...props}>
		<g fill="none" fillRule="evenodd">
			<path fill="#4758A9" fillRule="nonzero" d="M0 0h100v100H0z" />
			<g fillRule="nonzero">
				<path fill="#FFF" d="M38.65.163h5.482v4.386L4.877 44.022H.272V38.76z" />
				<path fill="#ED5565" d="M44.132.163L.272 44.023V40.951L41.72.162h1.535z" />
				<path fill="#FFF" d="M.272 5.426V.163h4.605l39.255 38.596v5.263H38.43z" />
				<path fill="#ED5565" d="M44.132 44.022H41.062L.272 3.013V.163z" />
				<path fill="#FFF" d="M16.939.163h10.526v43.86H16.939z" />
				<path fill="#FFF" d="M44.132 16.83v10.526H.272V16.829z" />
				<path
					fill="#ED5565"
					d="M25.272 19.022h18.86v6.14h-18.86v18.86h-6.14v-18.86H.272v-6.14h18.86V.162h6.14v18.86z"
				/>
			</g>
			<path d="M0 24h24V0H0z" />
			<path
				fill="#000"
				d="M49 0L15.666 16.5 49 0zM-1 8.25l16.666 8.25L-1 8.25zm16.666 8.25L49 33 15.666 16.5zM-1 24.75l16.666-8.25L-1 24.75zM15.666 16.333L-1 8l16.666 8.333zM-1 24.667l16.666-8.334L-1 24.667z"
			/>
			<path
				fill="#FFF"
				d="M65 18.584l3.709 2.832L67.292 26 71 23.167 74.708 26l-1.416-4.584L77 18.584h-4.584L71 14l-1.416 4.584zM49 38.201l3.708 2.597L51.292 45 55 42.403 58.708 45l-1.416-4.202L61 38.201h-4.584L55 34l-1.416 4.201zM83 36.201l3.708 2.597L85.292 43 89 40.403 92.708 43l-1.416-4.202L95 36.201h-4.584L89 32l-1.416 4.201zM65 66.965l4.017 3.07L67.483 75l4.017-3.07L75.517 75l-1.534-4.966L78 66.965h-4.966L71.5 62l-1.534 4.965z"
			/>
			<path
				fill="#ED5565"
				d="M67 19.056l2.472 1.888L68.528 24 71 22.112 73.472 24l-.944-3.056L75 19.056h-3.056L71 16l-.944 3.056zM51 38.8l2.472 1.732-.944 2.801L55 41.603l2.472 1.73-.944-2.8L59 38.8h-3.056L55 36l-.944 2.8zM85 36.8l2.472 1.732-.944 2.801L89 39.603l2.472 1.73-.944-2.8L93 36.8h-3.056L89 34l-.944 2.8zM67 67.437l2.781 2.125L68.72 73l2.781-2.125L74.281 73l-1.062-3.438L76 67.437h-3.438L71.5 64l-1.062 3.437z"
			/>
		</g>
	</svg>
);

export default FlagNZ;
